module.exports = __webpack_public_path__ + "1d32e25c696c5bc631520e3a019286e7.svg";